import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {NgForm} from "@angular/forms";
import {AdminService} from "../service/admin.service";
import {LoadingController, ModalController, IonModal, ToastController, Platform} from "@ionic/angular";
import {Constant} from "../shared/model/Constant";
import {AuthService} from "../service/auth.service";
import { CurrencyPipe } from '@angular/common';

declare var google: any;
const geoLoc = new google.maps.Geocoder();


@Component({
  selector: 'app-shops',
  templateUrl: './shops-self-management.page.html',
  styleUrls: ['./shops-self-management.page.scss'],
})
export class ShopsPageSe implements OnInit {


  @ViewChild('form', {static: false}) ngForm: NgForm;
  @ViewChild(IonModal) modal: IonModal;
  @ViewChild('map') mapElement: ElementRef;
  contacts: any[] = [{}];
  flagNaturalPerson: any;
  documents: any;
  loading: any;
  activities: any;
  typeaccounts: any[];
  banks: any[];
  accountNumber: any;
  countries: any[];
  departments: any[];
  cities: any[];
  socialNetworkn: any[] = [{}];
  socialNetworks: any;
  areas: any;
  fileType: string;
  urlRutUploaded: string;
  urlIdPhotocopyUploaded: string;
  urlBankCertificationUploaded: string;
  urlContractUploaded: string;
  taxRegimes: any;
  taxRegimeId: number;
  select = false;
  document: any;
  phone: any;
  cellPhone: any;
  nitdigit: any;
  firstName: any;
  secondName: any;
  firstLastName: any;
  secondSurName: any;
  cellPhoneRep: any;
  commerceId: string;
  isFormDatashopsComplete = false;
  isFormAccountingInformationShops = false;
  documentRep: any;
  isFormContactsShops = false;
  isFormDocumentsShops = false;
  isFormBillingShops = false;
  isFormBusinessInformation = false;
  isFormSocialNetworknShops = false;
  isFormCosigners = false;
  isFormStatements = false;
  webPage: string;
  businnescategories: any[];
  phoneRep: any;
  administrativeExpenses: any;
  providersDebt: any;
  salesMonthly: any;
  inventoryValue: any;
  businnesHousings: any;
  RegisteredBy: any;
  formattedProvidersDebt: string;
  auxProvidersDebt: string | number;
  amount: any;
  auxamount: string | number;
  providersDebt2: any;
  test: string;
  auxSalesMonthly: number;
  auxAdministrativeExpenses: string | number;
  auxInventoryValue: string | number;
  filteredActivities: any[] =[];
  selectedActivity: any;
  registeredBy: any;
  disableSaveButton = false;   //expresion para deshabilitar el boton de guardar en seccion informacion contable
  //PARA EXTRAER LA UBICACION
  address: string;
  showConfirm = false;
  cityId: any;
  departmentId: any;
  countryId: any;
  cityName: any;
  marker: any;
  latUser: any;
  lngUser: any;
  plusCodeUser: any;
  isMobile: any;



  constructor(
      private authService: AuthService,
      private adminService: AdminService,
      public loadingController: LoadingController,
      public toastController: ToastController,
      public modalController: ModalController,
      private currencyPipe: CurrencyPipe,
      private platform: Platform,) {

  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
      
    });
    await this.loading.present();
    localStorage.setItem('user_id', '80007');
    this.getBusinessActivityCiiu();
    this.getCountries();
    this.getDepartmentsCountries();
    this.getCitiesDepartments();
    this.getSocialNetworks();
    this.getAreaDirectories();
    this.getFiscalResponsibility();
    this.getCategoryBusiness();
    this.getTypeIdentificationId();
    this.getTypeHousing();
    this.getToken();
    this.filteredActivities = [];
    this.getTypeaccountbank();
    this.getBanks();   
    this.askForLocationPermission();
    this.verifyPlatform();


  }

  openMap() {
    this.showConfirm = true;
    const userAddress = this.address+", "+this.cityName;
    console.log(userAddress);

    setTimeout(() => {      //esperamos para iniciar el mapa para evitar errores
      
      this.geocodeAddress(userAddress).then((location) => {     
        this.initMap(location.lat(), location.lng(), 18);
      
      }).catch((error) => { //en caso de no poder localizar la direccion ingresada se abre el mapa en la ciudad seleccionada
        console.error('No se pudo hacer la geocodificació de la dirección ingresada:', error);
        this.getCityCoordenates().then(({longitud, latitud}) => {
        this.initMap(latitud, longitud, 12);

        }).catch((error) => {
          console.error("No se pudo realizar ningúna geolocalizacion..... iniciando mapa con ubicación por defecto", error);
          this.initMap(4.61744,-74.06884, 10);      // Coordenadas de ubicación predeterminada BOGOTA
          console.log("");
        });
      });    }, 100);
      this.modal.onDidDismiss().then(() => {
        this.closeMap();
      });

  }
  
  async initMap(latitude: number, longitude: number, zoom: number) {
    //@ts-ignore
      const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
      const map = new Map(                            //CREA UN  NUEVO MAPA
        document.getElementById('map') as HTMLElement,
        {
          zoom: zoom,
          center: { lat: latitude, lng: longitude },
          mapId: 'MAP_ID',
        }
      );
         //CREA UN MARCADOR PARA MOSTRAR EN EL CENTRO DEL MAPA
      this.marker = new google.maps.Marker({         
        position: map.getCenter(),
        map: map,
        title: 'marker',
        draggable: true
      });

      //ACTUALIZA EL MARCADOR AL CENTRO MOVER EL MAPA 
      map.addListener('drag', () => { this.marker.setPosition(map.getCenter()); });    
      map.addListener('zoom_changed', () => { this.marker.setPosition(map.getCenter()); });  
  }

  async setAddress() {        //RECIBE LA UBICACION SELECCIONADA EN EL MARCADOR
    try {
      const posicionMarcador = this.marker.getPosition();
      this.latUser = posicionMarcador.lat();
      this.lngUser = posicionMarcador.lng();
      await this.getPlusCode(this.latUser, this.lngUser);  
      console.log('Ubicacion Guardada...', this.latUser, this.lngUser, this.plusCodeUser);
      this.closeMap();
      this.presentToast('Tu Ubicación Ha Sido Registrada Con Exito', 'locate-sharp');
    }catch (error) {
      this.presentToast('Tu Ubicación No Se Ha Podido Registrar, Por Favor Abre el Mapa E Intenta Nuevamente...', 'alert-circle-sharp');
      console.error('No se pudo guardar la ubicación ', error);
    }
    
  }

  getCityCoordenates(): Promise<any> {
    const request = {
      address: this.cityName
    }
    return new Promise((resolve, reject) => {
      geoLoc.geocode(request, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
          const ubicacion = results[0].geometry.location;
          const longitud = ubicacion.lng();
          const latitud = ubicacion.lat();
          resolve({ longitud, latitud });
        } else {
          reject(new Error(`No se pudo obtener la longitud y latitud para ${this.cityName}`));
        }
      });
    });
  }

  async getPlusCode(latitud: number, longitud: number) {          //EXTRAE EL PLUS CODE POR MEDIO DE LAS COORDENADAS DEL MARCADOR
    const ubicacion = new google.maps.LatLng(latitud, longitud);

    const resultado = await new Promise((resolve, reject) => {
      geoLoc.geocode({ 'location': ubicacion }, (results, status) => {
        if (status === 'OK') {
          resolve(results);
        } else {
          reject(new Error(`Geocoder falló con el estado: ${status}`));
        }
      });
    });
    console.log('Resultado Geodificacion inversa: ', resultado);
    if (resultado) {
      const plusCode = resultado[0].plus_code;          
      if (plusCode) {   
        this.plusCodeUser = plusCode.global_code;           //guarda plus code del marcador
      } else {
        console.error("No se encontró el Plus Code en la respuesta.");
      }
    } else {
      console.error("No se encontraron resultados de geocodificación.");
    }

  }
 
  geocodeAddress(address: string): Promise<any> {       //EXTRAE LAS COORDENADAS DE LA DIRECCION INGRESADA
    return new Promise((resolve,reject) => {
      geoLoc.geocode({ 'address': address }, (results, status) => {
        if (status == 'OK') {
          resolve(results[0].geometry.location);
        } else {
          reject('Error en el metodo de Geolocalización ' + status);
        }
      });
    });
  }

  askForLocationPermission() {                //SOLICITA LA UBICACION AL USUARIO POR MEDIO DEL NAVEGADOR
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => this.showPosition(position));
    } else {
      console.error('ERROR: La geolocalización no es compatible con el navegador');
    }
  }

  showPosition = (position: GeolocationPosition) => {     //MUESTRA LA UBICACION Y ASIGNA COORDENADAS
    this.latUser = position.coords.latitude;
    this.lngUser = position.coords.longitude;
    this.getPlusCode(this.latUser, this.lngUser);    
  }

  closeMap() {
    const mapElement = document.getElementById('map');
    if(mapElement) {
      mapElement.innerHTML = '';
    }
    this.showConfirm = false;
  }

  verifyPlatform() {
    console.log('platform: ', this.platform.platforms());
    if (this.platform.is('mobile')) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    console.log('respuesta movil', this.isMobile);

  }

  log() {
    console.log(this.flagNaturalPerson)
  }

  async addContact() {
    this.contacts.push({});
  }

  async removeContact(index: number) {
    this.contacts.splice(index, 1);
  }


  async addSocialNeworks() {
    this.socialNetworkn.push({});

  }

  async removeSocialNeworks(index: number) {
    this.socialNetworkn.splice(index, 1);
  }

  getToken() {
      let data = {
        document: 9999999,                
        password: 'X%fq8$*Q_M3A9fai4AcEdkL2K5Pa$3'
      };
      this.authService.login(data).subscribe((res: any) => {
        localStorage.setItem(Constant.token, res.token);
      }, error => {
        console.log("No se pudo obtener el token para el registro del comercio");
      });
  }

  getTypeaccountbank() {
    this.loading.present();
    this.adminService.getTypeaccountbank().subscribe((res: any) => {
      this.typeaccounts = res;
      console.log(this.typeaccounts)
      this.loading.dismiss();
    });
  }

  getBanks() {
    this.loading.present();
    this.adminService.getBanks().subscribe((res: any) => {
      this.banks = res;
      console.log(this.banks)
      this.loading.dismiss();
    });
  }

  getTypeIdentificationId() {
    this.loading.present();
    this.adminService.getTypeIdentificationId().subscribe((res: any) => {
      this.documents = res;
      console.log(this.documents)
      this.loading.dismiss();
    });
  }

  getCategoryBusiness() {
    this.loading.present();
    this.adminService.getCategoryBusiness().subscribe((res: any) => {
      this.businnescategories = res;
      console.log(this.businnescategories)
      this.loading.dismiss();
    });

  }

  getTypeHousing() {
    this.loading.present();
    this.adminService.getTypeHousing().subscribe((res: any) => {
      this.businnesHousings = res;
      console.log(this.businnesHousings)
      this.loading.dismiss();
    });

  }

  getBusinessActivityCiiu() {
    this.loading.present();
    this.adminService.getSupplierBusinessActivityCiiu().subscribe((res: any) => {
      this.activities = res;
      console.log(this.activities)
      this.loading.dismiss();
    });
  }

  getCountries() {
    this.loading.present();
    this.adminService.getCountries().subscribe((res: any) => {
      this.countries = res;
      this.loading.dismiss();
    });
  }

  getDepartmentsCountries(countryId?) {
    this.loading.present();
    this.adminService.getDepartments(countryId).subscribe((res: any) => {
      this.departments = res;
      this.loading.dismiss();
    });
  }

  getCitiesDepartments(departmentId?) {
    this.loading.present();
    this.adminService.getCities(departmentId).subscribe((res: any) => {
      this.cities = res;
      this.loading.dismiss();
    });
  }

  getSocialMediaUrl(id: any) {
    if (this.socialNetworks) {
      const socialNetwotk = this.socialNetworks.filter(i => i.socialNetworkId === id);
      if (socialNetwotk.length > 0) {
        const url = socialNetwotk[0].logoUrl;
        console.log('return img', url);
        return url;
      }
    }
  }


  getSocialNetworks() {
    this.loading.present();
    this.adminService.getSocialNetworks().subscribe((res: any) => {
      this.socialNetworks = res;
      console.log(this.socialNetworks)
      this.loading.dismiss();
    });
  }

  getAreaDirectories() {
    this.loading.present();
    this.adminService.getContactAreaDirectories().subscribe((res: any) => {
      this.areas = res;
      console.log(this.areas)
      this.loading.dismiss();
    });
  }

  getFiscalResponsibility() {
    this.loading.present();
    this.adminService.getFiscalResponsibility().subscribe((res: any) => {
      this.taxRegimes = res;
      this.loading.dismiss();
    });

  }

  getCityNameById() {
    const indexCity = this.cities.findIndex(city => city.cityId === this.cityId);
    const indexDpt = this.departments.findIndex(dept => dept.departmentId === this.departmentId);
    const indexCountry = this.countries.findIndex(country => country.countryId === this.countryId);
    this.cityName = this.cities[indexCity].name + ', ' + this.departments[indexDpt].name + ', ' + this.countries[indexCountry].name;      //variable con nombre de ciudad, departamento y pais para ubicar la ciudad sin margen de error
    console.log('cityname'+this.cityName);
  }


  changeRuntFile(event: any) {
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = {route: res.url};
        this.urlRutUploaded = res.url;
        this.adminService.createDocuments(data,null, this.commerceId, null ).subscribe((day: any) => {
        })
        this.isFormDocumentsShops=true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }

  changeIdPhotocopyFile(event: any) {
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = {route: res.url};
        this.urlIdPhotocopyUploaded = res.url;
        this.adminService.createDocuments(data,null, this.commerceId, null ).subscribe((day: any) => {
        })
        this.isFormDocumentsShops=true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }

  changeBankCertificationFile(event: any) {
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = {route: res.url};
        this.urlBankCertificationUploaded = res.url;
        this.adminService.createDocuments(data,null, this.commerceId, null ).subscribe((day: any) => {
        })
        this.isFormDocumentsShops=true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }

  changeContractFile(event: any) {
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = {route: res.url};
        this.urlContractUploaded = res.url;
        this.adminService.createDocuments(data,null, this.commerceId, null ).subscribe((day: any) => {
        })
        this.isFormDocumentsShops=true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }

  }


  selectCheckbox2(checkboxIndex: number) {
    this.taxRegimeId = checkboxIndex;
    this.select = true;
    const checkboxCount = 5;
    for (let i = 0; i < checkboxCount; i++) {
      if (i !== checkboxIndex) {
        const checkboxElement = document.getElementsByClassName('checkbox3')[i] as HTMLIonCheckboxElement;
        checkboxElement.checked = false;
      }
    }
  }


  changeCountry(event: any) {
    if (event && event.detail && event.detail.value) {
      this.getDepartmentsCountries(event.detail.value);
    }
  }


  changeDepartment(event: any) {
    if (event && event.detail && event.detail.value) {
      this.getCitiesDepartments(event.detail.value);
    }
  }

  validateOnlyLetters() {
    if (this.firstName) {
      this.firstName = String(this.firstName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondName) {
      this.secondName = String(this.secondName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.firstLastName) {
      this.firstLastName = String(this.firstLastName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondSurName) {
      this.secondSurName = String(this.secondSurName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
  }

  validateOnlyLettersArray(index: number) {
    const contact = this.contacts[index];
    if (contact.name) {
      contact.name = contact.name.replace(/[^a-zA-ZñÑ\s]/g, '');
    }
  }


  validateOnlyNumbersShops() {
    if (this.document) {
      this.document = this.document.replace(/\D/g, '');
      this.document = this.document.substring(0, 20);

    }
    if (this.phone) {
      this.phone = this.phone.replace(/\D/g, '');
      this.phone = this.phone.substring(0, 11);
    }
    if (this.cellPhone) {
      this.cellPhone = this.cellPhone.replace(/\D/g, '');
      this.cellPhone = this.cellPhone.substring(0, 11);
    }
    if (this.nitdigit) {
      this.nitdigit = this.nitdigit.replace(/\D/g, '');
      this.nitdigit = this.nitdigit.substring(0, 2);

    }
    if (this.providersDebt) {
      this.providersDebt = this.providersDebt.replace(/\D/g, '');
      this.providersDebt = this.providersDebt.substring(0, 25);
    }
    if (this.salesMonthly) {
      this.salesMonthly = this.salesMonthly.replace(/\D/g, '');
      this.salesMonthly = this.salesMonthly.substring(0, 25);
    }
    if (this.administrativeExpenses) {
      this.administrativeExpenses = this.administrativeExpenses.replace(/\D/g, '');
      this.administrativeExpenses = this.administrativeExpenses.substring(0, 25);

    }
    if (this.inventoryValue) {
      this.inventoryValue = this.inventoryValue.replace(/\D/g, '');
      this.inventoryValue = this.inventoryValue.substring(0, 25);

    }
    if (this.phoneRep) {
      this.phoneRep = this.phoneRep.replace(/\D/g, '');
      this.phoneRep = this.phoneRep.substring(0, 11);

    }
    if (this.cellPhoneRep) {
      this.cellPhoneRep = this.cellPhoneRep.replace(/\D/g, '');
      this.cellPhoneRep = this.cellPhoneRep.substring(0, 12);

    }
    if (this.accountNumber) {
      this.accountNumber = this.accountNumber.replace(/\D/g, '');
      this.accountNumber = this.accountNumber.substring(0, 25);
      this.disableSaveButton = !(/^\d{5,25}$/.test(this.accountNumber));    //condicion que valida el campo numero de cuenta y si la expresion regular se cumple devuelve false, lo que habilita el boton guardar
    }

  }
  
  

  validateOnlyNumbersArray(index: number) {
    const contact = this.contacts[index];
    if (contact.phone) {
      contact.phone = contact.phone.replace(/\D/g, '');
    }
  }

  validateOnlyAmount() {
    try {
      if (this.providersDebt) {
        let amountNumber = this.providersDebt.split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxProvidersDebt = Number(amountNumber.split(".").join(''));
        this.providersDebt = this.currencyPipe.transform(this.auxProvidersDebt, 'COP', 'symbol-narrow', '1.0-0');
      }
      if (this.salesMonthly) {
        let amountNumber = this.salesMonthly.split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxSalesMonthly = Number(amountNumber.split(".").join(''));
        this.salesMonthly = this.currencyPipe.transform(this.auxSalesMonthly, 'COP', 'symbol-narrow', '1.0-0');
      }
      if (this.administrativeExpenses) {
        let amountNumber = this.administrativeExpenses.split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxAdministrativeExpenses = Number(amountNumber.split(".").join(''));
        this.administrativeExpenses = this.currencyPipe.transform(this.auxAdministrativeExpenses, 'COP', 'symbol-narrow', '1.0-0');
      }
      if (this.inventoryValue) {
        let amountNumber = this.inventoryValue.split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxInventoryValue = Number(amountNumber.split(".").join(''));
        this.inventoryValue = this.currencyPipe.transform(this.auxInventoryValue, 'COP', 'symbol-narrow', '1.0-0');
      }

    } catch (error) {
      console.log("Error en valor: " + error);
    }
  }

  async basicDataShops(data) {
    //TODO fixme : data mocked
    await this.loading.present();
    const userId = localStorage.getItem('user_id');
    if (!userId) {
      console.error('User ID no está disponible');
      return;
    }
    data.userId = userId;
    // @ts-ignore
    data.isNaturalPerson = this.flagNaturalPerson === 'true' || this.flagNaturalPerson === true;
    data.classCiiu = this.selectedActivity.classCiiu;
    data.latitude = this.latUser;
    data.longitude = this.lngUser;  
    data.codePlus = this.plusCodeUser;
      this.authService.createCommerce(data).subscribe((response: any) => {
      localStorage.setItem(Constant.commerceId, response.commerceId);
      this.commerceId = response.commerceId;
      this.loading.dismiss();
      this.presentToast('Datos básicos fueron guardados con éxito');
      this.isFormDatashopsComplete = true;
      this.ngForm.reset();
      this.close(true);
    }, error => {
      console.warn('Error al guardar los datos básicos', error);
      this.loading.dismiss();
      this.presentToast('Error al Guardar los Datos básicos');
     });

  }

  async presentToast(txt, icono?) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      icon: icono? icono : undefined,
      color: 'primary'
    });
    toast.present();
  }

  async close(data: any) {
    await this.modalController.dismiss(data);
  }

  async accountingInformationShops(value) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    await this.loading.present();
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    // @ts-ignore
    if(this.flagNaturalPerson==='false'){
      value.identificationTypeRepId= value.typeIdentificationId
    }
    const userId = localStorage.getItem('user_id');
    if (!userId) {
      console.error('User ID no está disponible');
      return;
    }
    this.registeredBy = userId;
    value.registeredBy = this.registeredBy;
    value.userId = userId;
    value.taxRegimeId = this.taxRegimeId
    this.authService.accountingInformationShops(this.commerceId, value).subscribe(response => {
      console.log(this.commerceId, value);

      this.loading.dismiss();
      this.presentToast('Datos contables fueron guardados con éxito');
      this.isFormAccountingInformationShops = true;
      this.close(true);
    }, error => {
      console.warn('Error al guardar datos contables', error);
      this.loading.dismiss();
      this.presentToast('Error al guardar datos contables');
    });
    this.adminService.saveBankInformationCommerce(this.commerceId, value).subscribe(response => {
      console.log(this.commerceId, value);
      this.loading.dismiss();
      this.isFormAccountingInformationShops = true;
      this.close(true);
    }, error => {
      console.warn('Error al guardar Informacion bancaria', error);
      this.loading.dismiss();
      this.presentToast('Error al guardar la información bancaria');
    });
  }

  filterActivities(event: any) {
    const searchTerm = event.target.value.toLowerCase();
  
    if (searchTerm.length >= 2) {
      this.filteredActivities = this.activities.filter(activity =>
        activity.name.toLowerCase().includes(searchTerm) ||
        activity.classCiiu.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredActivities = [];
    }
  }

  selectActivity(activity: any) {
    this.selectedActivity = activity;
    this.filteredActivities = [];
    console.log('Esta es la actividad seleccionada:', this.selectedActivity);  
  }


  async saveInformationNeworksShops() {
    const commerceId = localStorage.getItem(Constant.commerceId);
    const userId = localStorage.getItem(Constant.userId);
    this.RegisteredBy = userId;
    this.socialNetworkn.forEach(socialNetwork => {
      socialNetwork.webPage = this.webPage,
      this.RegisteredBy;
      this.adminService.createShopsInformationNeworks(socialNetwork, commerceId).subscribe(res => {
            console.log(res);
            this.presentToast('Datos redes sociales guardados con éxito');
            this.isFormSocialNetworknShops = true;
          }, error => {
            console.warn('Error al guardar redes sociales', error);
            this.loading.dismiss();
            this.presentToast('Error al guardar redes sociales');
          }
      );
    });

  }

  async saveContacShops() {
    const commerceId = localStorage.getItem(Constant.commerceId);
    this.contacts.forEach(contact => {
      this.adminService.createContacts(contact, null, commerceId, null).subscribe(res => {
            console.log(res);
            this.presentToast('Datos básicos de contactos guardados con éxito');
            this.isFormContactsShops = true;
            this.ngForm.reset();

          }, error => {
            console.warn('Error al guardar contactos', error);
            this.loading.dismiss();
            this.presentToast('Error al guardar contactos');
          }
      );
    });
  }
/*
  openUrl(url: string) {
    if (url) {
      window.open(url);
    }
  }*/

  async accountingInformationBusinessShops(value) {

    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    await this.loading.present();
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    value.providersDebt = this.auxProvidersDebt;
    value.salesMonthly = this.auxSalesMonthly;
    value.administrativeExpenses = this.auxAdministrativeExpenses;
    value.inventoryValue = this.auxInventoryValue;
    this.authService.accountingInformationBusinessShops(this.commerceId, value).subscribe(response => {
      console.log(this.commerceId, value);

      this.loading.dismiss();
      this.presentToast('Información de negocio guardada con éxito');
      this.isFormBusinessInformation = true;
      this.close(true);
    }, error => {
      console.warn('Error al guardar información de negocio', error);
      this.loading.dismiss();
      this.presentToast('Error al guardar información de negocio');
    });


  }

  addSocialNeworksShops() {
    this.socialNetworkn.push({});

  }
}
